import { render, staticRenderFns } from "./umfragen.vue?vue&type=template&id=286f19a4&scoped=true"
import script from "./umfragen.vue?vue&type=script&lang=js"
export * from "./umfragen.vue?vue&type=script&lang=js"
import style0 from "./umfragen.vue?vue&type=style&index=0&id=286f19a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f19a4",
  null
  
)

export default component.exports